import {Link} from 'react-router-dom'

const Product = ({product}) => {
    return (
        <div className="card border-0 shadow">
            <img src={product.iamge} loading='lazy' style={{height: "200px", width: "100%"}} className="card-img-top" alt={product.name} />
            <div className="card-body">
                <h5 className="card-title">{product.name}</h5>
                <p className='fw-bold'>Price: ${product.price}</p>
                <p style={{fontSize: "13px"}} className="card-text">{product.description.slice(0, 57)}</p>
                <Link to={`/product/${product.slug}`} className="btn btn-primary">View Product</Link>
            </div>
        </div>
    )
}

export default Product;